import React, { useMemo } from 'react';
import { GoalStatusCard } from '../GoalStatusCard/GoalStatusCard';
import { useGoalsContext } from '../GoalsContext/GoalsContext';
import { GoalWeightValidation } from '../useGoalWeightValidation';
import { GoalBase, GoalId, GoalViewBy } from '../types';
import { getGroupId, getGroupName, groupGoals } from './groupLogic';

type Props = {
  goals: GoalBase[];
  onGoalClick: (goalId: GoalId) => void;
  viewBy: GoalViewBy;
  goalWeightValidation: GoalWeightValidation;
};

export const GoalsList: React.FC<Props> = ({
  goals,
  onGoalClick,
  viewBy,
  goalWeightValidation,
}) => {
  const { employeeAssignedCategories, isManagerView } = useGoalsContext();
  const { invalidCategoryIds, errorsByCategoryId } = goalWeightValidation;
  const groupedGoals = groupGoals(goals, viewBy);

  const categoryWeightMap = useMemo(() => {
    const map = new Map<string, number | null>();
    for (const assignment of employeeAssignedCategories) {
      map.set(assignment.categoryId, assignment.weight ?? null);
    }
    return map;
  }, [employeeAssignedCategories]);

  return (
    <div>
      {Array.from(groupedGoals.entries()).map(([groupKey, curGroupGoals]) => {
        const groupDescription =
          viewBy === 'category'
            ? curGroupGoals[0]?.category?.description ?? undefined
            : undefined;
        return (
          <GoalStatusCard
            key={groupKey}
            groupName={getGroupName(groupKey)}
            groupDescription={groupDescription}
            goals={curGroupGoals}
            onGoalClick={onGoalClick}
            categoryId={
              viewBy === 'category' ? getGroupId(groupKey) : undefined
            }
            categoryWeight={
              viewBy === 'category' && !isManagerView
                ? categoryWeightMap.get(getGroupId(groupKey)) ?? null
                : null
            }
            invalidCategoryIds={invalidCategoryIds}
            errorsByCategoryId={errorsByCategoryId}
          />
        );
      })}
    </div>
  );
};
